import React from 'react';

const PermissionGroupUserFormModal = React.lazy(() => import('../components/FormModal'));
const permissionGroupUserModalRegistry = {
    core_permissionGroupUserId: PermissionGroupUserFormModal
};
export default permissionGroupUserModalRegistry;
